import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import './index.scss';
import {
    Input,
    Button,
    LatestEvent
} from 'components';
import { 
    ActiveShipmentsContext,
    AuthContext,
    HomeContext, 
    ManagementContext, 
    ShipmentInfoContext,
    TrackShipmentContext, 
} from 'contexts';
import { useHistory } from 'react-router-dom';
import { GET_FILE, PERMISSIONS_LIST, TASK_PAGE_SIZE } from 'actions';
import { useTranslation } from 'react-i18next';

export const ShipmentDetailsCard = ({ className = '', shipment, onShowDetails, isDetails = false, isCardDetails = false, shipmentDetails = {} }) => {
    const { t } = useTranslation();
    const { isArchive, currentTabManagement, permission, orgAvatars} = useContext(HomeContext);
    const { doUpdateShipmentNote } = useContext(ShipmentInfoContext);
    const [isEditBC, setIsEditBC] = useState(false);
    const [shipmentNote, setShipmentNote] = useState();
    const { doGetActiveShipmentsDetails, hasSearchData } = useContext(ActiveShipmentsContext);
    const { doGetShipmentInfo } = useContext(ShipmentInfoContext);
    const { doGetTaskManagements } = useContext(ManagementContext);
    const { trackerEvent, trackerObject, doGetTrackerEvent } = useContext(TrackShipmentContext);
    const { userInfo } = useContext(AuthContext);
    const history = useHistory();
    const consigneeIdShipment = shipmentDetails?.linkedShipment?.consigneeLinkedShipment?.id;
    const shipperIdShipment = shipmentDetails?.linkedShipment?.shipperLinkedShipment?.id;

    const [refresh, setRefresh] = useState(false);
    /*eslint-disable */
    useEffect(() => {
        setShipmentNote(shipmentDetails && shipmentDetails.note ? shipmentDetails.note.content : '')
    }, [shipmentDetails])

    useEffect(() => {
        if (hasSearchData || shipmentDetails?.searchParameter) {
            doGetTrackerEvent(
                {
                    type: trackerObject?.mbl ? 'BL' : 'BK',
                    scac: trackerObject?.scac,
                    trackingNo: trackerObject?.mbl || trackerObject?.bkc,
                    // poiLocode: tracker && tracker.locations && tracker.locations.length > 0 && tracker.locations[0].locode,
                    // vesselIMO: tracker && tracker.vessels && tracker.vessels.length > 0 && tracker.vessels[0].imo,
                    // lowerBoundDate: new Date(shipmentDetails?.arrivalDate),
                    // upperBoundDate: new Date(shipmentDetails?.departureDate)
                },
                () => {
                    setRefresh(false);
                },
                () => {setRefresh(false);}
            );
        }
    }, [trackerObject])
    /*eslint-enable*/

    const toggleEditBC = () => {
        if (!isArchive) {
            setShipmentNote(shipmentNote);
            setIsEditBC(!isEditBC);
        }
    };

    const canPressButton = () => {
        return shipmentDetails && shipmentDetails?.roleInShipments?.some(role => ['SHIPMENT_ADMIN', 'SHIPPER', 'CONSIGNEE'].includes(role?.roleType) && role?.partners?.some(partner => partner?.id === userInfo?._id));
    }

    const handleRedirectPage = (linkedIdShipment) => {
        doGetActiveShipmentsDetails(linkedIdShipment);
        doGetShipmentInfo(linkedIdShipment);
         const params = {
            page: 0,
            limit: TASK_PAGE_SIZE,
            tab: currentTabManagement
        }
        doGetTaskManagements(linkedIdShipment, params, () => {});
        if(linkedIdShipment) {
            history.push(`/${isArchive ? 'archive' : 'active-shipments'}/${linkedIdShipment}`);
        }
    }

    const handleUpdateShipmentNote = () => {
        shipmentDetails.note = shipmentNote;
        doUpdateShipmentNote(shipment._id, shipmentNote, () => {
            setShipmentNote(shipmentNote);
            setIsEditBC(false);
        });
    }

    const handleCancelUpdateShipmentNote = (e) => {
        setIsEditBC(false);
        setShipmentNote(shipment.note ? shipment.note.content : 'act');
    }

    const checkPermission = (action) => {
        return permission?.shipmentFunctions.includes(action);
    }

    const handleReFreshData = () => {
        setRefresh(true);
        doGetTrackerEvent(
            {
                type: trackerObject?.mbl ? 'BL' : 'BK',
                scac: trackerObject?.scac,
                trackingNo: trackerObject?.mbl || trackerObject?.bkc,
            },
            () => {
                setRefresh(false);
            },
            () => {setRefresh(false);}
        );
    }


    return shipmentDetails ? (
        <div className={`tr__active-shipment-item ${className}`}>
            <div className="tr__active-shipment-item--body">
                <div className="tr__active-shipment-item--header box-header d-flex align-items-center">
                    {shipmentDetails?.addresses && shipmentDetails.addresses.pol && shipmentDetails.addresses.pod && (
                        <h4 className="h4 f-medium">
                            {isArchive && !isDetails && shipmentDetails?.status && (
                                <span className={`status-tag text-capitalize ${shipmentDetails.status}`}>{shipmentDetails.status}</span>
                            )}
                            {shipmentDetails && shipmentDetails.shipmentName}
                        </h4>
                    )}
                    <div className="note d-flex">
                        {isEditBC ? (
                            <div className="edit-form d-flex align-items-center">
                                <Input
                                    defaultValue={shipmentDetails && shipmentDetails.note && shipmentDetails.note.content}
                                    placeholder={t("home.active-shipment.add-note")}
                                    value={shipmentNote}
                                    onChange={e => setShipmentNote(e.target.value)}
                                />
                                <Button
                                    className="mlx1 outline"
                                    onClick={handleUpdateShipmentNote}
                                >
                                    {t("home.active-shipment.save-note")}
                                </Button>
                                <Button
                                    className="mlx1 outline"
                                    onClick={handleCancelUpdateShipmentNote}
                                >
                                    {t("home.active-shipment.cancel")}
                                </Button>
                            </div>
                        ) : (
                            <>
                                {shipmentDetails.note && (
                                    <span>{shipmentNote || ''}</span>
                                )}
                                <>
                                    <i className="icon-pencil" onClick={toggleEditBC} />
                                </>
                            </>
                        )}
                    </div>
                    <div className="shipment d-flex align-items-center">
                        <div className="info">
                            {!isArchive && (
                                <i className={shipmentDetails && shipmentDetails.shippingDetails && shipmentDetails.shippingDetails.shipmentType === 'FCL' ? 'icon-container-solid' : 'icon-boxes-solid'} />
                            )}
                            <span>{shipmentDetails && shipmentDetails.shippingDetails && shipmentDetails.shippingDetails.shipmentType}</span>

                            {(!!shipmentDetails?.containersNumb || !!shipmentDetails?.packetsNumb) && (
                                <span className='no-of-product'>
                                    {(shipmentDetails?.containersNumb) ? `${shipmentDetails?.containersNumb} Container` : `${shipmentDetails?.packetsNumb} Packet`}{(shipmentDetails?.containersNumb > 1 || shipmentDetails?.packetsNumb > 1) ? 's' : ''}
                                </span>
                            )}
                        </div>
                        {shipmentDetails.openIssuesNumber > 0 && (
                            <span className="task-warning d-flex align-items-center mlx2">
                                <i className="icon-warning mrx1" />
                                <span>{shipmentDetails.openIssuesNumber} open</span>
                            </span>
                        )}
                    </div>
                </div>
                <div className="plx3 ptx2 d-flex">
                    <div className="mrx1">
                        <p>Planned: 
                            <span className="f-medium mlx1">
                                N/A
                                {/* {plannedTransitTime ? plannedTransitTime : 'N/A'} day{plannedTransitTime > 1 ? 's' : ''} */}
                            </span></p>
                        <p>Carrier: {trackerEvent?.carrierTransitTime ? <span className="f-medium carrier-time">
                            {trackerEvent?.carrierTransitTime} day{trackerEvent?.carrierTransitTime > 1 ? 's' : ''} (Actual)
                            </span> : 'N/A'}
                        </p>
                    </div>
                    <Button
                        className={`${refresh ? 'loading-btn' : '' } icon outline reload`}
                        icon="icon-refresh"
                        type="secondary"
                        onClick={handleReFreshData}
                    />
                </div>
                {trackerEvent ?  
                    <div className="tr__active-shipment-item--steps d-flex">
                        <LatestEvent 
                            trackerEvent={trackerEvent}
                            tracker={trackerObject?.trackerResponse}
                            trackPoint={trackerObject?.trackPoint}
                            trackerObject={trackerObject}
                        />
                    </div>
                    : 
                    <div className="no-result f-medium">No data available yet</div>
                }
            </div>
            <div className="tr__active-shipment-item--footer">
                {isDetails ? (
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="shipment-teams d-flex align-items-center">
                            <i className="icon-shipper active" />
                            <i className="icon-box active" />
                            <i className="icon-truck" />
                            <i className="icon-box-export" />
                            <i className="icon-box-import" />
                            <i className="icon-export" />
                            <i className="icon-import" />
                        </div>
                    </div>
                ) : (
                    <>
                        {isCardDetails && <div className="tr__active-shipment-item--footer--icon d-flex align-items-center justify-content-between">
                                <div className ="d-flex">
                                    {orgAvatars && orgAvatars.length > 0 && (
                                        <>
                                            {orgAvatars.map((org, roleIndex) => (
                                            <>
                                             {org.orgLogo ? <img src={GET_FILE + org.orgLogo} alt={org?.orgLogo} key={roleIndex} /> : <i className="logo-default icon-organization" />} 
                                            </>
                                            ))}
                                        </>
                                    )}
                                </div>
                            <div>
                            {shipmentDetails?.isLinkedShipment === false && !isEmpty(shipmentDetails?.linkedShipment?.consigneeLinkedShipment) && 
                            checkPermission(PERMISSIONS_LIST.SHIPMENT_VIEW_LINKED_SHIPMENT) && <Button
                                className="tr__link-shipment-create mrx3"
                                onClick={() => handleRedirectPage(consigneeIdShipment)}
                                disabled={!canPressButton()}
                            >
                                {t("home.active-shipment.link_shipment")} : {shipmentDetails?.linkedShipment?.consigneeLinkedShipment?.shipmentName}
                            </Button>
                            }

                            {shipmentDetails?.isLinkedShipment === false && !isEmpty(shipmentDetails?.linkedShipment?.shipperLinkedShipment) && 
                            checkPermission(PERMISSIONS_LIST.SHIPMENT_VIEW_LINKED_SHIPMENT) && <Button
                                className="tr__link-shipment-create mrx3"
                                onClick={() => handleRedirectPage(shipperIdShipment)}
                                disabled={!canPressButton() && !checkPermission(PERMISSIONS_LIST.SHIPMENT_VIEW_LINKED_SHIPMENT)}
                            >
                                {t("home.active-shipment.link_shipment")} : {shipmentDetails?.linkedShipment?.shipperLinkedShipment?.shipmentName}
                            </Button>
                            }
                            {/* {(!isArchive && checkPermission(PERMISSIONS_LIST.SHIPMENT_CREATE_LINKED_SHIPMENT)) && (
                                <>
                                {(shipmentDetails?.isLinkedShipment || (!isEmpty(shipmentDetails?.linkedShipment?.consigneeLinkedShipment) && !isEmpty(shipmentDetails?.linkedShipment?.shipperLinkedShipment?.id))) ? '' : <Button
                                className="outline mrx3"
                                onClick={() => {
                                    doGetLocodes({ limit: LOCODE_PAGE_SIZE });
                                    doGetTemplates({
                                        tab: MINE,
                                        limit: 9999,
                                        page: ALL,
                                    });
                                    doGetDocuments(shipmentDetails?.permission?.shipmentId, {
                                        page: 0,
                                        limit: DOCUMENT_PAGE_SIZE
                                    }, () => {
                                    })
                                    // useEffect(() => {
                                    //     doGetOrganizations({ page: 0, limit: ORGANIZATION_PAGE_SIZE });


                                    //     if (firstLocode && firstLocode.length > 0) {
                                    //         setOrigins(firstLocode);
                                    //         setDestinations(firstLocode);
                                    //     }
                                    // }, [])
                                    setAddLink(true);
                                }}
                            >
                                {t("home.active-shipment.create-linked-shipment")}
                            </Button>
                            }
                                </>
                            )} */}

                            </div>
                        </div>
                        }
                    </>
                )}
            </div>
        </div>
    ) : '';
};

ShipmentDetailsCard.propTypes = {
    isDetails: PropTypes.bool,
    className: PropTypes.string,
    shipment: PropTypes.object,
    onShowDetails: PropTypes.func
};
